/**
 * Fuji Bikes Custom Header JS
 * - Transitions background from transparent to solid on scroll (transparent mode only)
 * - Mega menu hover event binding
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-fuji-header]');
  if (!header) return;

  /* ------------------------------------------------
     Scroll: transparent → solid (transparent mode only)
     ------------------------------------------------ */
  var isTransparent = header.dataset.transparent === 'true';

  if (isTransparent) {
    var SCROLL_THRESHOLD = 10;

    function handleScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      if (scrollY > SCROLL_THRESHOLD) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // run once on init
  }

  /* ------------------------------------------------
     Mega Menu hover – show overlay
     ------------------------------------------------ */
  var megaItems = header.querySelectorAll('[data-has-mega-menu]');

  megaItems.forEach(function (item) {
    var link = item.querySelector('.fuji-nav__link');
    var menu = item.querySelector('.fuji-mega-menu');

    item.addEventListener('mouseenter', function () {
      header.classList.add('has-open-menu');
      if (link) link.setAttribute('aria-expanded', 'true');
      if (menu) menu.removeAttribute('aria-hidden');
    });

    item.addEventListener('mouseleave', function () {
      header.classList.remove('has-open-menu');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (menu) menu.setAttribute('aria-hidden', 'true');
    });
  });

  /* ------------------------------------------------
     Mobile menu drawer (< 768px)
     Submenus use native <details>, so only open/close
     state, scroll lock and dismissal need JS.
     ------------------------------------------------ */
  var menuToggle = header.querySelector('[data-fuji-menu-toggle]');
  var mobileMenu = header.querySelector('[data-fuji-mobile-menu]');

  if (menuToggle && mobileMenu) {
    function openMobileMenu() {
      header.classList.add('is-mobile-menu-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
      if (!header.classList.contains('is-mobile-menu-open')) return;
      header.classList.remove('is-mobile-menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    menuToggle.addEventListener('click', function () {
      if (header.classList.contains('is-mobile-menu-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    // Close button(s) and the backdrop overlay
    header.querySelectorAll('[data-fuji-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMobileMenu);
    });

    // Tapping a real navigation link closes the drawer
    mobileMenu.querySelectorAll('[data-fuji-menu-link]').forEach(function (el) {
      el.addEventListener('click', closeMobileMenu);
    });

    // Esc closes
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMobileMenu();
    });

    // Resizing up to desktop closes (and restores scroll)
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) closeMobileMenu();
    });
  }
})();
